<div class="grid">
  <div class="col-12">
    <div class="card">
      <object *ngIf="loaded" [data]="url + '#toolbar=0&navpanes=0' | safeUrl"
              type="application/pdf" width="100%" height="600px"></object>
    </div>
  </div>
</div>
